// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1wXoF","inputDescription":"styles_inputDescription__2XjTN"};